/**
 * 登录注册模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../utils/http'; // 导入http中创建的axios实例

const article = {
//获取文章列表
  commit (params) {
    return axios.post(`${base.system}/mail`,params);
  },
  
};

export default article;
